<template>
  <div class="item-comments" v-if="data">
    <div class="flex">
      <div class="item-comments__content">
        {{ data.CONTENT }}
      </div>
      <span class="fs14 ml-5 cs-pointer" @click="checkUpdate = true">수정</span>
      <span class="fs14 ml-5 cs-pointer" @click="onDelete">삭제</span>
    </div>

    <div class="explainBox mt-1" v-if="checkUpdate">
      <div class="title flex flexAlignS">
        <h5>답글</h5>
        <div class="fs14 cs-pointer" @click="onUpdate">등록</div>
      </div>
      <div class="textAreaBox">
        <textarea v-model="content"></textarea>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ItemComment",
  props: ["data"],
  data() {
    return {
      checkUpdate: false,
      content: this.data.CONTENT,
    };
  },
  methods: {
    onDelete() {
      this.$emit("onDelete");
    },
    onUpdate() {
      this.checkUpdate = false;
      this.$emit("onUpdate", {
        idx: this.data.IDX,
        content: this.content,
      });
    },
  },
};
</script>
